import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import MachineDropdown from './MachineDropdown';
import {jwtDecode} from 'jwt-decode';  // Import jwt-decode to decode the token
import { ApiBaseUrlContext } from '../App';
import { formatDateByLocale } from '../utils/dateUtils';
import '../boxitem.css';
import '../Button.css';
import '../forms.css';
import '../filter.css';
import '../topmenu.css';
import './FaultError.css';
//import './FaultError.css';
import { ReactComponent as FilterIcon } from '../assets/svg/icon-filter.svg';
import { ReactComponent as AddIcon } from '../assets/svg/icon-add.svg';
import { ReactComponent as SectionToggleArrow } from '../assets/svg/icon-toggle-section-arrow.svg';
//import Dropdown from 'react-bootstrap/Dropdown';
//import DropdownButton from 'react-bootstrap/DropdownButton';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import BoxItem from './BoxItem';
import '../table-list-2.css';
import GroupedDataTable from './GroupDataTable2'; 					 
							 

const FaultError = () => {
  const { t, i18n } = useTranslation(); // Access the translation function
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const [showContent, setShowContent] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showClosedOnly, setShowClosedOnly] = useState(false);
  const [faults, setFaults] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [groups, setGroups] = useState([]);
  const [machines, setMachines] = useState([]);
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState(null);
const [userRights, setUserRights] = useState(null);
  const [filter, setFilter] = useState({
    dncmaxgroupname: '',
    priority: '',
    machine: '',
    technician: '',
    status: '',
  });
  const [newFault, setNewFault] = useState({
    machine: '',
    machineid: '',
    description: '',
    technician: '',
    priority: 'Low',
    status: 'New',
    completed: false,
    materialsUsed: [{ name: '', cost: '', unit:'', quantity:''}], // ✅ Initialize this
    files: [],
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [timezone, setTimezone] = useState('UTC');
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();

  const [permissions, setPermissions] = useState({ can_edit: false, can_delete: false ,can_view: true }); // Default to view only
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
  
    const decodedToken = jwtDecode(token);
    const userId = decodedToken.userid;
    const userRights = decodedToken.user_rights;
  
    // 🔹 Fetch Permissions and User Info
    const fetchUserDetails = async () => {
      try {
        // 🔸 Step 1: Fetch Permissions
        const permissionsResponse = await axios.get(
          `${apiBaseUrl}/mnt/api/roles/permissions/${userRights}`
        );
        console.log('Fetched permissions:', permissionsResponse.data);
  
        setPermissions({
          can_edit: permissionsResponse.data.some(permission => permission.permission_name === 'can_edit' && permission.can_edit === 1),
          can_view: permissionsResponse.data.some(permission => permission.permission_name === 'can_view' && permission.can_view === 1),
          can_delete: permissionsResponse.data.some(permission => permission.permission_name === 'can_delete' && permission.can_delete === 1)
        });
  
        // 🔸 Step 2: Fetch User Info if not Admin
        if (userId === 1) {
          setUserName('Admin');
        } else {
          const userResponse = await axios.get(`${apiBaseUrl}/mnt/api/technicians/${userId}`);
          const { userfirstname, userlastname } = userResponse.data;
          
          // ✅ Set the full name in a single field
          setUserName(`${userfirstname} ${userlastname}`);
        }
      } catch (error) {
        console.error('Error fetching user details or permissions:', error);
        setUserName(t('unknownUser'));
      }
    };
  
    // Trigger the fetch
    fetchUserDetails();
  }, [apiBaseUrl]);
  /*const decodeToken = useCallback(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        return {
          userid: decodedToken.userid,
          user_rights: decodedToken.user_rights,
        };
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
    return { userid: null, user_rights: null };
  }, []);*/
  const fetchFaults = useCallback(async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/fault-errors`, {
        params: {
          ...filter,
          // If "All" (status is empty), don't send the status param to get everything except "Closed"
          status: filter.status || undefined,
        },
        headers: {
          Accept: 'application/json',
        },
      });
  
      // Filter out "Closed" faults explicitly (only keep "New" and "Open")
      const filteredFaults = response.data.filter(
        (fault) => fault.status === 'New' || fault.status === 'Open'
      );
  
      // Fetch service report IDs for "Open" faults
      const faultsWithServiceReports = await Promise.all(
        filteredFaults.map(async (fault) => {
          if (fault.status === 'Open' && fault.id) {
            try {
              const serviceReportResponse = await axios.get(`${apiBaseUrl}/mnt/api/service-reports/byFault`, {
                params: { faultID: fault.id },
                headers: { Accept: 'application/json' },
              });
  
              if (serviceReportResponse.data && serviceReportResponse.data.servicereportid) {
                return { ...fault, serviceReportId: serviceReportResponse.data.servicereportid };
              }
            } catch (err) {
              console.error(t('FaultError.errors.serviceReportError', { faultId: fault.id }), err);
            }
          }
          return fault;
        })
      );
  
      // Sort faults
      const sortedFaults = faultsWithServiceReports.sort((a, b) => {
        if (a.status === 'New' && b.status !== 'New') return -1;
        if (a.status !== 'New' && b.status === 'New') return 1;
        if (a.status === 'New' && b.status === 'New') {
          const priorityOrder = { High: 1, Medium: 2, Low: 3 };
          return priorityOrder[a.priority] - priorityOrder[b.priority];
        }
        if (a.status === 'Open' && b.status === 'Open') {
          return b.created - a.created;
        }
        return 0;
      });
  
      // Set the sorted faults to state
      setFaults(sortedFaults);
    } catch (error) {
      console.error(t('FaultError.errors.fetchFaultsError'), error);
    }
  }, [apiBaseUrl, filter, t]);
  

  const fetchTechnicians = useCallback(async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/technicians`, {
        headers: { Accept: 'application/json' },
      });
      const filteredTechnicians = response.data.filter(tech =>
        tech.user_rights === 'external technician' || tech.user_rights === 'internal technician'
      );
      setTechnicians(filteredTechnicians);
    } catch (error) {
      console.error(t('FaultError.errors.fetchTechniciansError'), error);
    }
  }, [apiBaseUrl, t]);

  const convertToEpoch = (dateTime) => {
    return new Date(dateTime).getTime();
  };
  
  const fetchGroups = useCallback(async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/machines/groups`, {
        headers: { Accept: 'application/json' },
      });
      setGroups(response.data);
    } catch (error) {
      console.error(t('FaultError.errors.fetchGroupsError'), error);
    }
  }, [apiBaseUrl, t]);

  const fetchMachines = useCallback(async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/machines/all`, {
        headers: { Accept: 'application/json' },
      });
      setMachines(response.data);
    } catch (error) {
      console.error(t('FaultError.errors.fetchMachinesError'), error);
    }
  }, [apiBaseUrl, t]);

  useEffect(() => {
    const savedTimezone = localStorage.getItem('timezone');
    if (savedTimezone) {
      setTimezone(savedTimezone);
    }
    fetchFaults();
    fetchTechnicians();
    fetchGroups();
    fetchMachines();
  }, [fetchFaults, fetchTechnicians, fetchGroups, fetchMachines]);

  useEffect(() => {
    if (machines.length === 0) return; // Wait until machines are loaded

    const params = new URLSearchParams(location.search);
    const machineIdFromURL = params.get('machineId');

    if (machineIdFromURL) {
      // Find the machine from the list
      const selectedMachine = machines.find(machine => machine.machineid.toString() === machineIdFromURL);
      if (selectedMachine) {
        setNewFault(prevState => ({
          ...prevState,
          machine: selectedMachine.machine,
          machineid: selectedMachine.machineid
        }));
      }

      // Open the form automatically
      setShowForm(true);
      setShowContent(false);
    }
  }, [location, machines]);
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    const uploadedFiles = [];
  
    for (const file of files) {
      const formData = new FormData();
      formData.append('files', file);
  
      try {
        const response = await axios.post(`${apiBaseUrl}/mnt/api/fault-errors/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        // Spread the returned array to avoid nesting arrays.
        uploadedFiles.push(...response.data);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
  
    // Merge with any already uploaded files
    setNewFault((prevFault) => ({
      ...prevFault,
      files: [...(prevFault.files || []), ...uploadedFiles],
    }));
  };
  
  const handleRemoveFile = (index) => {
    setNewFault((prevFault) => {
      const updatedFiles = prevFault.files.filter((_, i) => i !== index);
      return { ...prevFault, files: updatedFiles };
    });
  };
    // ✅ Get token from storage20250225
  const handleAddFault = async () => {
    if(newFault.machine === ''){
      setErrorMessage(t('FaultError.errors.selectMachine'));
      return;
    }
    try {
      const token = localStorage.getItem('token');  
      const technicianToSend = newFault.completed && !newFault.technician
      ? userName
      : newFault.technician;
      const payload = {
        machineid: newFault.machineid,
        machine: newFault.machine,
        description: newFault.description,
        technician: technicianToSend,
        priority: newFault.priority,
        status: newFault.completed ? 'Closed' : 'New',
        timeFrom: newFault.completed ? convertToEpoch(newFault.timeFrom) : null,
        timeTo: newFault.completed ? convertToEpoch(newFault.timeTo) : null,
        completionDescription: newFault.completionDescription || '',
        timeDescription: newFault.timeDescription || '',  
        files: newFault.files || [],
        materialsUsed: newFault.materialsUsed || [], // Include array
      };
      
      

      if (isEditing) {
        await axios.patch(`${apiBaseUrl}/mnt/api/fault-errors/${editId}`, payload, {
          headers: { Authorization: `Bearer ${token}` }, // Add token to headers 20250225
        });
        setIsEditing(false);
        setEditId(null);
      } else {
        await axios.post(`${apiBaseUrl}/mnt/api/fault-errors`, payload, {
          headers: { Authorization: `Bearer ${token}` }, //  Add token to headers
        });
      }
      fetchFaults();
      setNewFault({
        machine: '',
        machineid: '',
        description: '',
        technician: '',
        priority: 'Low',
        status: 'New',
        materialsUsed: [{ name: '', cost: '', unit:'', quantity:''}],
        files: ''
      });
      setShowForm(false);
      setShowContent(true);
    } catch (error) {
      
      console.error(t('FaultError.errors.addFaultError'), error);
    }
  };
  const handleDeleteFile = async (index) => {
    // Only call the deletion endpoint when editing an existing fault
    if (!isEditing) {
      // For new faults, you can simply update the state.
      setNewFault((prevFault) => {
        const updatedFiles = prevFault.files.filter((_, i) => i !== index);
        return { ...prevFault, files: updatedFiles };
      });
      return;
    }
  
    const file = newFault.files[index];
    try {
      const token = localStorage.getItem('token');
      // Send a DELETE request with the filename in the body.
      await axios.delete(`${apiBaseUrl}/mnt/api/fault-errors/${editId}/file`, {
        data: { filename: file.filename },
        headers: { Authorization: `Bearer ${token}` }
      });
      // Update the state after deletion
      setNewFault((prevFault) => {
        const updatedFiles = prevFault.files.filter((_, i) => i !== index);
        return { ...prevFault, files: updatedFiles };
      });
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };
  const handleEditFault = (index) => {
    const faultToEdit = faults[index];
      // Parse the files JSON if necessary
  let filesArray = [];
  if (faultToEdit.files) {
    try {
      // Parse the JSON if it’s a string.
      let parsed = typeof faultToEdit.files === 'string'
        ? JSON.parse(faultToEdit.files)
        : faultToEdit.files;
      // If it's nested, flatten it.
      filesArray = Array.isArray(parsed) ? parsed.flat() : [];
    } catch (error) {
      console.error('Error parsing files JSON:', error);
    }
  }
  console.log(filesArray);
    setNewFault({
      machine: faultToEdit.machine,
      machineid: faultToEdit.machineid,
      description: faultToEdit.description,
      technician: faultToEdit.technician,
      priority: faultToEdit.priority,
      status: faultToEdit.status,
      files: filesArray, // Set the files from the record
    });
    setIsEditing(true);
    setEditId(faultToEdit.id);
    setShowContent(false);
    setShowForm(true);
  };

  const handleDeleteFault = async (id) => {
    const testidFault = faults[id];
    const testid = testidFault.id;
    const confirmDelete = window.confirm(t('FaultError.prompts.confirmDeleteFault'));
    console.log(testid);
    if (confirmDelete) {
      try {
        await axios.delete(`${apiBaseUrl}/mnt/api/fault-errors/${testid}`);
        fetchFaults();
      } catch (error) {
        console.error(t('FaultError.errors.deleteFaultError'), error);
      }
    }
  };

  const handleSelectMachine = (machine) => {
    if (!machine) {
      console.error(t('FaultError.errors.noMachineSelected'));
      setNewFault({ ...newFault, machine: '', machineid: '' });
      return;
    }
    setNewFault({ ...newFault, machine: machine.machine, machineid: machine.machineid });
  };

  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  const applyFilters = () => {
    fetchFaults();
  };

  const getPriorityClass = (priority) => {
    switch (priority) {
      case 'High':
        return 'badge-danger';
      case 'Medium':
        return 'badge-warning';
      case 'Low':
        return 'badge-success';
      default:
        return '';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'High':
        return 'red';
      case 'Medium':
        return 'yellow';
      case 'Low':
        return 'green';
      default:
        return '';
    }
  };
    

  const formatEpochForDisplay = (epoch) => {
    return formatDateByLocale(Math.floor(epoch / 1000), i18n.language);
  };
  

  const handleOpenFault = async (fault) => {
    try {
      if (fault.status !== 'New') {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/service-reports/byFault`, {
          params: { faultID: fault.id },
          headers: { Accept: 'application/json' },
        });

        const serviceReports = response.data;

        if (serviceReports && serviceReports.servicereportid) {
          navigate('/service-reports', {
            replace: true, // Force route reload 20250225
            state: { mode: 'edit', fault, serviceReportId: serviceReports.servicereportid },
          });
        } else {
          console.error(t('FaultError.errors.noServiceReportFound'));
        }
      } else {
        navigate('/service-reports', {
          replace: true, // Force route reload 20250225
          state: { mode: 'create', fault, faultId: fault.id }, 
        });
      }
    } catch (error) {
      console.error(t('FaultError.errors.openFaultError'), error);
    }
  };
  const handleResetFilter = () => {
    setFilter({
      dncmaxgroupname: '',
      priority: '',
      machine: '',
      technician: '',
      status: 'New',
    });
    setShowClosedOnly(false); // If you want to reset "Closed Only" too
  
    // Refetch after resetting
    fetchFaults();
  };
const openFaults = faults.filter((fault) => fault.status === "Open");
const newFaults = faults.filter((fault) => fault.status === "New");

const groupedFaults = {
  [t("FaultError.titles.newErrors")]: faults.filter((f) => f.status === "New"),
  [t("FaultError.titles.openErrors")]: faults.filter((f) => f.status === "Open"),
};	



 return (

  <div>

    {showFilters && (
    
      <div className="filter-container" onClick={() => setShowFilters(!showFilters)}>
        <div className="filter" onClick={(e) => e.stopPropagation()}>
          <div className="filter__fields">


            <div className="filter__label">{t('FaultError.labels.groupName')}</div>
            <div className="entry-item">
              <select
                id="dncmaxgroupname"
                name="dncmaxgroupname"
                className="form-select"
                value={filter.dncmaxgroupname}
                onChange={handleFilterChange}
              >
                <option value="">{t('FaultError.placeholders.all')}</option>
                {groups.map((group) => (
                  <option key={group} value={group}>
                    {group}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter__label">{t('FaultError.labels.priority')}</div>
            <div className="entry-item">
              <select
                id="priority"
                name="priority"
                className="form-select"
                value={filter.priority}
                onChange={handleFilterChange}
              >
                <option value="">{t('FaultError.placeholders.all')}</option>
                <option value="Low">{t('FaultError.priorities.low')}</option>
                <option value="Medium">{t('FaultError.priorities.medium')}</option>
                <option value="High">{t('FaultError.priorities.high')}</option>
              </select>
            </div>

            <div className="filter__label">{t('FaultError.labels.machine')}</div>
            <div className="entry-item">
              <select
                id="machine"
                name="machine"
                className="form-select"
                value={filter.machine}
                onChange={handleFilterChange}
              >
                <option value="">{t('FaultError.placeholders.all')}</option>
                {machines.map((machine) => (
                  <option key={machine.machineid} value={machine.machine}>
                    {machine.machine}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter__label">{t('FaultError.labels.technician')}</div>
            <div className="entry-item">
              <select
                id="technician"
                name="technician"
                className="form-select"
                value={filter.technician}
                onChange={handleFilterChange}
              >
                <option value="">{t('FaultError.placeholders.all')}</option>
                {technicians.map((technician) => (
                  <option
                    key={technician.userid}
                    value={`${technician.userfirstname} ${technician.userlastname}`}
                  >
                    {technician.userfirstname} {technician.userlastname}
                  </option>
                ))}
              </select>
            </div>
        
            <div className="filter__label">{t('FaultError.labels.status')}</div>
            <div className="entry-item">
              <select
                id="status"
                name="status"
                className="form-select"
                value={filter.status}
                onChange={handleFilterChange}
              >
                <option value="">{t('FaultError.placeholders.all')}</option>
                <option value="New">{t('FaultError.statuses.new')}</option>
                <option value="Open">{t('FaultError.statuses.open')}</option>
              </select>
            </div>
          
          </div>

          <div className="filter__buttons">
  <button
    type="button"
    className="button--grey"
    id="reset-filter"
    onClick={handleResetFilter}
  >
    {t('FaultError.buttons.reset')}
  </button>
</div>

        </div>
      </div>
   
    )}

    {showForm && (

      <div className="modal-full">

        <div className="top-menu">
          <button type="button" className="button--blue" onClick={handleAddFault}>{t('ServiceReport.save')}</button>
          <div className="top-menu__button-space"></div>
          <button 
            type="button" 
            className="button--grey" 
            onClick={() => {
              setShowForm(false);
              setShowContent(true);
            }}
          >{t('ServiceReport.cancel')}</button>
        </div>
            {/* Show the error message if we have one */}
    {errorMessage && (
      <div className="form-error">
        {errorMessage}
      </div>
    )}

        <div className="content__main-title">{isEditing ? t('FaultError.titles.editFault') : t('FaultError.titles.addFault')} </div>
  
        <div className="form-section">

          <div className="entry-item entry-item__content-width">
            <label className="entry-label">{t('FaultError.labels.machine')}</label>			

            {isEditing ? (
              <select disabled>
                <option value="">{newFault.machine}</option>
              </select>
            ) : (
              <MachineDropdown onSelectMachine={handleSelectMachine} value={newFault.machineid} multiSelect={false} />
            )}

          </div>

          <div className="entry-item">
            <div className=""><label className="entry-label">{t('FaultError.labels.faultDescription')}</label>
              <textarea 
                className="form-entry__textarea" 
                id="description"
                maxlength="500" 
                placeholder=""
                value={newFault.description}
                onChange={(e) => setNewFault({ ...newFault, description: e.target.value })}
              >
              </textarea>
            </div>
          </div>

          <div className="entry-item entry-item__content-width">
            <label className="entry-label">{t('FaultError.labels.technician')}</label>				
            <select
              id="technician"
              className="form-select"
              value={newFault.technician}
              onChange={(e) => setNewFault({ ...newFault, technician: e.target.value })}
            >
              <option value="firstavailable">{t('FaultError.placeholders.firstAvailable')}</option>
              {technicians.map((technician) => (
                <option
                  key={technician.userid}
                  value={`${technician.userfirstname} ${technician.userlastname}`}
                >
                  {technician.userfirstname} {technician.userlastname}
                </option>
              ))}
            </select>
          </div>

          <div className="entry-item entry-item__content-width">
            <label className="entry-label">{t('FaultError.labels.priority')}</label>				
            <select
              id="priority"
              className="form-select"
              value={newFault.priority}
              onChange={(e) => setNewFault({ ...newFault, priority: e.target.value })}
            >
              <option value="Low">{t('FaultError.priorities.low')}</option>
              <option value="Medium">{t('FaultError.priorities.medium')}</option>
              <option value="High">{t('FaultError.priorities.high')}</option>
            </select>
          </div>
{/* Checkbox for Marking as Completed */}
<div className="entry-item entry-item__content-width">
  <label className="entry-label">
    <input
      type="checkbox"
      checked={newFault.completed}
      onChange={(e) => {
        const completed = e.target.checked;
        setNewFault({
          ...newFault,
          completed,
          timeFrom: completed ? newFault.timeFrom : '', // Clear if not completed
          timeTo: completed ? newFault.timeTo : '',     // Clear if not completed
          completionDescription: completed ? newFault.completionDescription : '', 
          timeDescription: completed ? newFault.timeDescription : '' // New field
        });
      }}
      style={{ marginRight: '8px' }}
    />
    {t('FaultError.labels.alreadyCompleted')}
  </label>
</div>

{/* Render the time fields and descriptions only if "Completed" is checked */}
{newFault.completed && (
  <>
    <div className="entry-item entry-item__content-width">
      <label className="entry-label">
        {t('ServiceReport.CompletionDescription')}:
      </label>
      <textarea
        className="form-entry__textarea"
        value={newFault.completionDescription}
        onChange={(e) => setNewFault({ ...newFault, completionDescription: e.target.value })}
        placeholder={t('ServiceReport.EnterCompletionDescription')}
      />
    </div>

    {/* 🔹 Horizontal Time Entry Row */}
    <div className="time-entry-row">
      <div className="entry-item">
        <label>{t('ServiceReport.TimeFrom')}:</label>
        <input
          type="datetime-local"
          value={newFault.timeFrom}
          onChange={(e) => setNewFault({ ...newFault, timeFrom: e.target.value })}
        />
      </div>

      <div className="entry-item">
        <label>{t('ServiceReport.TimeTo')}:</label>
        <input
          type="datetime-local"
          value={newFault.timeTo}
          onChange={(e) => setNewFault({ ...newFault, timeTo: e.target.value })}
        />
      </div>

      <div className="entry-item">
        <label>{t('ServiceReport.TimeDescription')}:</label>
        <textarea
          className="form-entry__textarea"
          value={newFault.timeDescription}
          onChange={(e) => setNewFault({ ...newFault, timeDescription: e.target.value })}
          placeholder={t('ServiceReport.EnterTimeDescription')}
        />
      </div>
    </div>
    <div className="entry-item entry-item__content-width">
  <label className="entry-label">{t('ServiceReport.Materials')}</label>
  
  {newFault.materialsUsed.map((item, index) => (
  <div key={index} className="material-row" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
    <input
      type="text"
      className="form-entry__input"
      placeholder={t('ServiceReport.materialName')}
      value={item.name}
      onChange={(e) => {
        const updated = [...newFault.materialsUsed];
        updated[index].name = e.target.value;
        setNewFault({ ...newFault, materialsUsed: updated });
      }}
    />
    <input
      type="number"
      className="form-entry__input"
      placeholder={t('ServiceReport.materialCost')}
      value={item.cost}
      min="0"
      step="0.01"
      onChange={(e) => {
        const updated = [...newFault.materialsUsed];
        updated[index].cost = e.target.value;
        setNewFault({ ...newFault, materialsUsed: updated });
      }}
    />
    <input
      type="number"
      className="form-entry__input"
      placeholder={t('ServiceReport.materialQty')}
      value={item.quantity}
      min="1"
      onChange={(e) => {
        const updated = [...newFault.materialsUsed];
        updated[index].quantity = parseInt(e.target.value) || 1;
        setNewFault({ ...newFault, materialsUsed: updated });
      }}
    />
    <select
      className="form-select"
      value={item.unit}
      onChange={(e) => {
        const updated = [...newFault.materialsUsed];
        updated[index].unit = e.target.value;
        setNewFault({ ...newFault, materialsUsed: updated });
      }}
    >
                            <option value="pcs">{t('ServiceReport.Pcs')}</option>
                            <option value="set">{t('ServiceReport.Set')}</option>
                            <option value="hr">{t('ServiceReport.Hour')}</option>
                            <option value="day">{t('ServiceReport.Day')}</option>
                            <option value="km">{t('ServiceReport.Kilometer')}</option>
                            <option value="mile">{t('ServiceReport.Mile')}</option>
                            <option value="in">{t('ServiceReport.Inch')}</option>
                            <option value="ft">{t('ServiceReport.Feet')}</option>
                            <option value="yd">{t('ServiceReport.Yard')}</option>
                            <option value="meter">{t('ServiceReport.Meter')}</option>
                            <option value="cm">{t('ServiceReport.Cm')}</option>
                            <option value="mm">{t('ServiceReport.Mm')}</option>
                            <option value="l">{t('ServiceReport.Liter')}</option>
                            <option value="cl">{t('ServiceReport.Centiliter')}</option>
                            <option value="ml">{t('ServiceReport.Milliliter')}</option>
                            <option value="gallon">{t('ServiceReport.Gallon')}</option>
                            <option value="kg">{t('ServiceReport.Kg')}</option>
                            <option value="g">{t('ServiceReport.Gram')}</option>
                            <option value="oz">{t('ServiceReport.Ounce')}</option>
                            <option value="lb">{t('ServiceReport.Pound')}</option>
                            <option value="ton">{t('ServiceReport.Ton')}</option>
    </select>

    <button
      type="button"
      className="button--grey"
      onClick={() => {
        const updated = [...newFault.materialsUsed];
        updated.splice(index, 1);
        setNewFault({ ...newFault, materialsUsed: updated });
      }}
    >
      {t('ServiceReport.materialRemove')}
    </button>
  </div>
))}

  <button
    type="button"
    className="button--icon button--blue"
    onClick={() =>
      setNewFault({
        ...newFault,
        materialsUsed: [...newFault.materialsUsed, { name: '', cost: '' }],
      })
    }
  >
    {t('ServiceReport.material+addMaterial')}
  </button>
</div>

  </>
)}


          <div className="entry-item">
            <label className="entry-label">
              {t('FaultError.labels.attachments')}
            </label>

            <div className="file-upload">
              {/* Hidden file input */}
              <input 
                type="file" 
                multiple 
                onChange={handleFileChange} 
                id="faultErrorFileUpload" 
                className="file-upload__input" 
                style={{ display: "none" }} // Hide the default input
              />

              {/* Custom button to trigger file input */}
              <button 
                type="button" 
                className="button--icon button--grey"
                onClick={() => document.getElementById("faultErrorFileUpload").click()} // Trigger file input
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 29 29" 
                  width="20" 
                  height="20"
                >
                  <polygon 
                    points="21,14 15,14 15,8 14,8 14,14 8,14 8,15 14,15 14,21 15,21 15,15 21,15"
                    fill="black"
                  />
                  <rect width="29" height="29" fill="none"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Display uploaded files */}
          {newFault.files && newFault.files.length > 0 && (
            <div className="uploaded-files">
              {newFault.files.map((file, index) => (
                <div key={index} className="file-item">
                  <a
                    href={`${apiBaseUrl}/mnt/api/uploads/report/${file.filename}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {file.filename}
                  </a>
                  <button type="button" onClick={() => handleDeleteFile(index)}>
                  {t('ServiceReport.uploadRemove')}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="form-submit">
          <button type="button" className="button--blue" onClick={handleAddFault}>{t('ServiceReport.save')}</button>
          <div className="top-menu__button-space"></div>
          <button 
            type="button" 
            className="button--grey" 
            onClick={() => {
              setShowForm(false);
              setShowContent(true);
            }}
          >{t('ServiceReport.cancel')}</button>
        </div>

      </div>

    )}

    {showContent && (
      <div className="content">
        <div className="top-menu">
          <div className="top-menu__divider"></div>
          <div className="top-menu__icon-button top-menu__filter-button" onClick={() => setShowFilters(!showFilters)}><FilterIcon /></div>
          {permissions.can_edit && (
            <button
              type="button"
              className="button--icon-add button--green"
              onClick={() => {
                setShowForm(true);
                setShowContent(false);
              }}
            >
              <AddIcon /> {t('FaultError.buttons.addError')}
            </button>
          )}
        </div>

        <div className="content__main-title">{t('FaultError.titles.reportedErrors')}</div>

   <GroupedDataTable
  groupedData={groupedFaults}
  isFiltered = {Object.values(filter).some(Boolean)}
  headers={[
    {
      label: t("FaultError.titles.faultId"),
      render: (fault) => `${t('FaultError.titles.faultId')}${fault.id} - ${fault.machine}`,
      hideMobile: false,
      colorStyle: "block",
      colorValueFrom: (f) => f.priority,
    },
    {
      label: t("detailedServiceReport.tableHeaders.description"),
      accessor: "description",
      elasticCell: true,
    },
    {
      label: t("FaultError.labels.status"),
      accessor: "status",
      hideMobile: true,
    },
    {
      label: t("FaultError.labels.priority"),
      accessor: "priority",
      hideMobile: true,
      colorStyle: "circle",
      colorValueFrom: (f) => f.priority,
    },
    {
      label: t("detailedServiceReport.tableHeaders.date"),
      render: (f) =>
        formatDateByLocale(Math.floor(f.created / 1000), i18n.language),
      hideMobile: true,
    },
    {
      label: t("FaultError.labels.reportedBy"),
      render: (f) => `${f.userfirstname} ${f.userlastname}`,
      hideMobile: true,
    },
  ]}
					   
  rowKeyFn={(f) => f.id}
  onPrimaryAction={(f) => handleOpenFault(f)}
  getPrimaryActionLabel={() => t("FaultError.labels.start")}
  contextualOptionsFn={(f) => [
    {
							
      label: t("FaultError.options.edit"),
      onClick: (e) => {
        e.preventDefault();
        handleEditFault(faults.indexOf(f));
      },
    },
    {
      label: t("FaultError.options.delete"),
      onClick: (e) => {
        e.preventDefault();
        handleDeleteFault(faults.indexOf(f));
      },
    },
  ]}
  groupMeta={{
    [t("FaultError.titles.newErrors")]: {
      title: t("FaultError.titles.newErrors"),
      description: t("FaultError.descriptions.newErrors"),
      emptyMessage: t("FaultError.messages.noNewErrors"),
    },
    [t("FaultError.titles.openErrors")]: {
      title: t("FaultError.titles.openErrors"),
      description: t("FaultError.descriptions.openErrors"),
      emptyMessage: t("FaultError.messages.noOpenErrors"),
    },
  }}
/>

      </div>

    )}


  </div>

  );
};

export default FaultError;

